


































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import TariffDetailBase from "./TariffDetailBase";

	@Component
	export default class TariffDetail extends TariffDetailBase {

	 	 	
		created() {
			this.returnRoute = "TariffList";
            super.initializeRights('ACC_Tariff_Update', 'ACC_Tariff_Update', 'ACC_Tariff_Update', 'ACC_Tariff_Update');
			super.setMainDescription('tariff.new', 'tariff.detail');
            this.mainDataChanged = false;
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
		}

        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		mounted() {
			super.mounted();
		};

		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}		

        isCorrectMaturityDay(value: any) {
            this.isCorrectMaturityDayBase(value);
        }

        isCorrectUrgentDay(value: any) {
            this.isCorrectUrgentDayBase(value);
        }

      
	}
